<ng-template #viewPopup2>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelViewPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label class="popupTitle" matTooltip="{{docViewer.docName}}">
      {{ displayName }}
    </label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold;">QMS</span></label>
  </div>

  <div style="margin: 10px 12px 0px 0px;" *ngIf="message.isDocumentDownloader">
    <div class="d-flex gap-2 action-buttons-container">

      <!-- Print button — single button, behavior branches by privilege inside printDocument() -->
      <!-- Print Administrator + Print User → OneQMS Print Tray popup                        -->
      <!-- Print User only                 → Native Windows OS print dialog                  -->
      <div
        class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="printDocument()"
        (keydown.enter)="printDocument()"
        [class.disabled-print-button]="!documentLoaded || isPrintButtonDisabled"
        [attr.aria-disabled]="(!documentLoaded || isPrintButtonDisabled).toString()"
        [matTooltip]="hasPrintTrayAccess
          ? 'Print via OneQMS Print Tray'
          : 'Print via Windows'">
        <span class="reload_text text-white">
          <i class="fa fa-print" aria-hidden="true"></i>&nbsp;&nbsp;Print
        </span>
      </div>

    </div>
  </div>

  <div style="margin: 15px 15px;" #webViewerContainer>
    <web-viewer-printer #webViewerComp
      [data]="docViewer.doc"
      (oneQmsListener)="onUserActivity()">
    </web-viewer-printer>
  </div>
</ng-template>

<!-- Printer popup — only shown for Print Tray path (Print Administrator) -->
<ng-template #printerPopup>
  <h2 mat-dialog-title>Select Printer</h2>

  <mat-dialog-content class="d-flex flex-column gap-3 overflow-hidden">

    <!-- Printer Selection -->
    <div class="row align-items-center mb-3">
      <label class="col-md-4 fw-semibold">Printer</label>
      <div class="col-md-8 d-flex align-items-center gap-2">
        <mat-select
          class="flex-grow-1 custom-select border p-2 rounded"
          [(ngModel)]="selectedPrinter">
          <mat-option *ngFor="let printer of printers" [value]="printer">
            {{ printer.displayName || printer.printerName }}
          </mat-option>
        </mat-select>
<button
  class="addIconContiner d-flex justify-content-center align-items-center"
  (click)="refreshPrinterList()"
  [disabled]="isProcessing"
  matTooltip="Refresh printer list"
  style="min-width: 38px; height: 38px; border: none; cursor: pointer;">
  <span class="reload_text text-white">
    <i class="fa fa-refresh" aria-hidden="true"></i>
  </span>
</button>
      </div>
    </div>

    <!-- Pages -->
    <div class="row align-items-center mb-3">
      <label class="col-md-4 fw-semibold">Pages</label>
      <div class="col-md-4">
        <select class="form-select custom-select" [(ngModel)]="pageSelection">
          <option value="ALL">All</option>
          <option value="CUSTOM">Customized</option>
        </select>
      </div>
      <div class="col-md-4" *ngIf="pageSelection === 'CUSTOM'">
        <input type="text" class="form-control"
          placeholder="e.g. 1-5"
          [(ngModel)]="customPages" />
      </div>
    </div>

    <!-- Orientation -->
    <div class="row align-items-center mb-3">
      <label class="col-md-4 fw-semibold">Orientation</label>
      <div class="col-md-8">
        <mat-select class="w-100 custom-select border p-2 rounded"
          [(ngModel)]="orientation">
          <mat-option value="PORTRAIT">Portrait</mat-option>
          <mat-option value="LANDSCAPE">Landscape</mat-option>
        </mat-select>
      </div>
    </div>

    <!-- Duplex -->
    <div class="row align-items-center mb-3">
      <label class="col-md-4 fw-semibold">Double-Sided</label>
      <div class="col-md-8">
        <div class="form-check form-switch pt-1">
          <input class="form-check-input" type="checkbox"
            id="duplexSwitch"
            [(ngModel)]="isDuplexEnabled">
          <label class="form-check-label" for="duplexSwitch">
            Print on both sides
          </label>
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="closePrinterPopup()">Cancel</button>
    <button type="button" mat-raised-button color="primary" (click)="confirmPrint()">
      Print
    </button>
  </mat-dialog-actions>
</ng-template>